import { vnAppZone } from "../../vendor/valnet/valnet_jslib/vnApp/vn_app_zone";
import { pageFactory } from "../modules/factory";


export class vnAppZoneHeader extends vnAppZone {

    public constructor(destination) {
        super(destination);
        this.zoneName = "Header";
    }

    defineRoutes() {
        let factory = new pageFactory();
        let _mythis = this;
        // Check if the user is on a mobile device
        const isMobile = /Android|webOS|iPhone|IEMobile|Opera Mini/i.test(navigator.userAgent);

        if (isMobile) {
            //define routes
            this.addForRoute('all', function () {

                // obtain the right module object
                let moduleObj = factory.get_actionHandler("header_pwa", _mythis);

                // load it into the zone
                _mythis.loadModule(moduleObj);
            }, null);

            this.addForRoute('/header_pwa', function () { }, null);
        }
        else {
            //define routes
            this.addForRoute('all', function () {

                // obtain the right module object
                let moduleObj = factory.get_actionHandler("header", _mythis);

                // load it into the zone
                _mythis.loadModule(moduleObj);
            }, null);

            this.addForRoute('/header', function () { }, null);
        }

    }
}



// WEBPACK FOOTER //
// ./js/components/vn_app_zone_header.ts